// Compatibilidad entre planes históricos y catálogo actual de EKINE.
// NO modifica precios, saldos, planes ni sesiones: solo busca la variante correcta.

export const normalizarPlanTexto = (valor) =>
  String(valor ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const familiaDe = (texto) => {
  const n = normalizarPlanTexto(texto);
  if (n.includes("kinesiolog")) return "kinesiologia";
  if (n.includes("entren")) return "entrenamiento";
  if (n.includes("recovery")) return "recovery";
  if (n.includes("masajes mitad")) return "masajes-mitad-semana";
  if (n.includes("masoter")) return "masoterapia";
  if (n.includes("masaj")) return "masajes";
  return n;
};

const periodoDe = (texto) => {
  const n = normalizarPlanTexto(texto);
  if (/\bsemestral\b/.test(n)) return "semestral";
  if (/\btrimestral\b/.test(n)) return "trimestral";
  if (/\bmensual\b/.test(n)) return "mensual";
  return null;
};

const frecuenciaDe = (texto) => {
  const n = normalizarPlanTexto(texto);
  const m = n.match(/\b([1-9])\s*(?:veces?|vez)\s*(?:(?:x|por|a la)\s*)?sem(?:ana)?\b/)
    || n.match(/\b([1-9])\s*x\s*(?:sem(?:ana)?)?\b/);
  return m ? Number(m[1]) : null;
};

const esPareja = (texto, explicito) =>
  explicito === true || /\bpareja\b/.test(normalizarPlanTexto(texto));

const variantesPlan = (p) => [p?.servicio_variante, p?.variante, p?.nombreVariante]
  .filter((x) => typeof x === "string" && x.trim());

export function coincidePlanConServicio(plan, servicio) {
  if (!plan || !servicio) return false;

  const textoCategoriaPlan = [plan.servicio_categoria, plan.categoria, plan.servicio]
    .filter(Boolean).join(" ");
  const categoriaCatalogo = servicio.categoria || servicio.servicioBase || "";
  const familiaPlan = familiaDe(textoCategoriaPlan);
  const familiaCatalogo = familiaDe(categoriaCatalogo);
  if (!familiaPlan || familiaPlan !== familiaCatalogo) return false;

  const textoPlan = `${textoCategoriaPlan} ${variantesPlan(plan).join(" ")}`;
  const textoServicio = `${categoriaCatalogo} ${servicio.variante || servicio.nombre || ""}`;
  if (familiaPlan === "entrenamiento" &&
      esPareja(textoPlan, plan.es_pareja) !== esPareja(textoServicio, servicio.es_pareja)) {
    return false;
  }

  // No cruzar frecuencias o duraciones cuando ambas están informadas.
  const periodoPlan = periodoDe(textoPlan);
  const periodoServicio = periodoDe(textoServicio);
  if (periodoPlan && periodoServicio && periodoPlan !== periodoServicio) return false;

  const frecuenciaPlan = frecuenciaDe(textoPlan);
  const frecuenciaServicio = frecuenciaDe(textoServicio);
  if (frecuenciaPlan && frecuenciaServicio && frecuenciaPlan !== frecuenciaServicio) return false;

  // Primero los identificadores estables, si ambos existen.
  const idPlan = normalizarPlanTexto(plan.varianteId || plan.variante_id || "");
  const idServicio = normalizarPlanTexto(servicio.varianteId || "");
  if (idPlan && idServicio && idPlan === idServicio) return true;

  const varianteServicio = normalizarPlanTexto(servicio.variante || servicio.nombre);
  if (!varianteServicio) return false;
  if (variantesPlan(plan).some((v) => normalizarPlanTexto(v) === varianteServicio)) return true;

  // Compatibilidad con nomenclaturas históricas, p. ej. «2x sem (mensual)»
  // frente a «2 veces x sem (mensual)». Exigir ambos atributos para no
  // confundir un mensual, trimestral, semestral o frecuencia diferente.
  return Boolean(
    familiaPlan === "entrenamiento" &&
    periodoPlan && periodoServicio && periodoPlan === periodoServicio &&
    frecuenciaPlan && frecuenciaServicio && frecuenciaPlan === frecuenciaServicio
  );
}

export const buscarServicioDePlan = (plan, catalogo = []) =>
  (catalogo || []).find((servicio) => coincidePlanConServicio(plan, servicio)) || null;
